import { CustomTable } from '../../../../../components'
import { WizardUserScheduleProps } from './typing'
import { useContextState } from '../../../../../hooks/theme'
import { Ref, forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { RefTable } from '../../../../../components/table/types'
import { DrawerData } from './drawerData'

const CurrentStep = forwardRef((props: WizardUserScheduleProps, ref: Ref<{ removeChecks?: (payload: { value: boolean }) => void }>) => {
  const refTable = useRef<RefTable>(null)
  const { colors } = useContextState()
  useImperativeHandle(ref, () => ({
    removeChecks: ({ value }: { value: boolean }) => {
      if (refTable?.current) {
        refTable?.current?.allChecksAreSelected?.({ value })
      }
    }
  }))

  const objectSteps: Record<string, JSX.Element> = {
    0: (
      <CustomTable
        ref={refTable}
        loader={!!props.isLoadingEndpoints?.users}
        dontRefresh
        tableChecks
        defaultChecks={props.selectSchedule ?? []}
        onClick={props.handleSelect}
        column={props.columns.column1}
        row={props.rows ?? []}
        color={colors}
        selected={-1}
      />
    ),
    1: (
      <CustomTable
        ref={refTable}
        tableRadio={!!props.id}
        loader={!!props.isLoadingEndpoints?.questionnaires}
        dontRefresh
        tableChecks
        defaultChecks={props.selectSchedule ?? []}
        onClick={props.handleSelect}
        column={props.columns.column2}
        row={props.rows ?? []}
        color={colors}
        selected={-1}
      />
    ),
    2: (
      <DrawerData
        mimTimeZone={props.mimTimeZone}
        items={props.items}
        setErrors={props.setErrors}
        flag={props.flag}
        setFlag={props.setFlag}
        setStartDate={props.setStartDate}
        startDate={props.startDate}
        selectedDays={props.selectedDays}
        setSelectedDays={props.setSelectedDays}
        children={props.children}
        childrenRef={props.childrenRef}
        setChildren={props.setChildren}
        setData={props.setData}
        loadings={props.loadings}
        columns={props.columns.column3}
        currentUser={props?.currentUser}
        data={props.data}
        diabledSaveSchedule={props.diabledSaveSchedule}
        errors={props.errors}
        handleCloseScheduleUser={props.handleCloseScheduleUser}
        handleSelect={props.handleSelect}
        keepSaveSchedule={props.keepSaveSchedule}
        onChange={props.onChange}
        refRange={props.refRange}
        refTable={refTable}
        rows={props.rows}
        selectSchedule={props.selectSchedule}
        userSelectes={props.userSelectes}
        disabledChecks={props.disabledChecks}
      />
    ),
  }

  useEffect(() => {
    if (refTable?.current) {
      refTable?.current?.resetPagination?.()
    }
  }, [props.steps])

  return objectSteps[props.steps] ?? <></>
})

export { CurrentStep }
